import { RootState } from "@/app/stores"
import { 
    IProfileResponse, 
    IUpdateContactRequest, 
    IDashboardStatusResponse,
    getOrganizationProfile as getOrganizationProfileRequest,
    updateContactPerson as updateContactPersonRequest,
    submitForModeration as submitForModerationRequest,
    getDashboardStatus as getDashboardStatusRequest
} from "@/shared/api/onboarding"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchOrganizationProfile = createAsyncThunk<
    IProfileResponse,
    void,
    { state: RootState }
>('onboarding/fetchOrganizationProfile', async(_, thunkAPI) => {
    try {
        const data = await getOrganizationProfileRequest()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchUpdateContactPerson = createAsyncThunk<
    IProfileResponse,
    IUpdateContactRequest,
    { state: RootState }
>('onboarding/fetchUpdateContactPerson', async(req, thunkAPI) => {
    try {
        const data = await updateContactPersonRequest(req)
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchSubmitForModeration = createAsyncThunk<
    IProfileResponse,
    void,
    { state: RootState }
>('onboarding/fetchSubmitForModeration', async(_, thunkAPI) => {
    try {
        const data = await submitForModerationRequest()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

export const fetchDashboardStatus = createAsyncThunk<
    IDashboardStatusResponse,
    void,
    { state: RootState }
>('onboarding/fetchDashboardStatus', async(_, thunkAPI) => {
    try {
        const data = await getDashboardStatusRequest()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})

